var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeRightNavSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45mm",
    height: "25mm",
    viewBox: "0 0 45 25",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.0720208
    },
    id: "rect4",
    width: 44.927979,
    height: 0.047979161,
    x: 0.036010396,
    y: 12.536011
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.0694941
    },
    id: "rect4-9",
    width: 24.930506,
    height: 0.080505908,
    x: -24.965252,
    y: 0.0347475,
    transform: "rotate(-90)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRightNavSvg);
export default __webpack_public_path__ + "static/media/home_right_nav_svg.6d91819cce2913745f794083ccc32445.svg";
export { ForwardRef as ReactComponent };